<template lang="pug">
include ../mixins
+b.scroll-top(
  @click.prevent="scrollTop"
  :class="{'is-active': isVisible}"
)
  +b.I.ls-icon.--type_up-chevron
</template>

<script>
export default {
  name: 'scroll-top-button',

  data() {
    return {
      isVisible: false,
    }
  },

  created() {
    document.onscroll = () => {
      this.updateScrollTopVisibility()
    }
  },

  methods: {
    updateScrollTopVisibility() {
      const offset = 150

      if (window.pageYOffset > offset) {
        this.isVisible = true
      } else {
        this.isVisible = false
      }
    },

    scrollTop() {
      const offset = 0
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      })
    },
  },
}
</script>
